module.exports = __webpack_public_path__ + "img/schedule.a8571b17.svg";